import { getDataFieldValue } from "./../../../TranslatableAPI/utils.js";
import { ENTITY_DECORATION_TO_MUTABILITY, TO_RICOS_DECORATION_TYPE } from "../consts.js";
import { convertDecorationToDraftData } from "./convertDraftPluginData.js";
import { createEntity } from "./create-entity.js";
const createDecorationEntityData = (decoration, entityKey) => {
  const { type, emojiData } = decoration;
  const data = emojiData || convertDecorationToDraftData({
    ...decoration,
    type: TO_RICOS_DECORATION_TYPE[type]
  });
  if (data === void 0) {
    throw Error(`ERROR! Unknown entity type "${type}"!`);
  }
  const mutability = ENTITY_DECORATION_TO_MUTABILITY[type];
  return createEntity(entityKey, { type, mutability, data });
};
const getDynamicStyles = (node) => {
  const data = getDataFieldValue(node);
  const textStyle = data && "textStyle" in data ? data.textStyle : {};
  const { textAlignment, lineHeight } = textStyle || {};
  const { paddingTop, paddingBottom } = node.style || {};
  return {
    textAlignment,
    lineHeight,
    paddingTop,
    paddingBottom
  };
};
const createTextBlockData = (node) => {
  const { indentation = 0 } = getDataFieldValue(node) || {};
  const { textAlignment, lineHeight, paddingTop, paddingBottom } = getDynamicStyles(node);
  return JSON.parse(
    JSON.stringify({
      textAlignment: textAlignment !== "AUTO" ? textAlignment?.toLowerCase() : void 0,
      dynamicStyles: (paddingTop || paddingBottom || lineHeight) && {
        "padding-top": paddingTop,
        "padding-bottom": paddingBottom,
        "line-height": lineHeight
      },
      depth: indentation
    })
  );
};
export {
  createDecorationEntityData,
  createTextBlockData
};
//# sourceMappingURL=getDraftEntityData.js.map
